var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMinusCircle = function SvgMinusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 .5C15.09.5.5 15.09.5 33S15.09 65.5 33 65.5 65.5 50.91 65.5 33 50.91.5 33 .5ZM33 7c14.398 0 26 11.602 26 26S47.398 59 33 59 7 47.398 7 33 18.602 7 33 7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.563 36.656v-7.312H48.42v7.312H17.563Z",
    fill: "currentColor"
  })));
};

export { SvgMinusCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjYiIGhlaWdodD0iNjYiIHZpZXdCb3g9IjAgMCA2NiA2NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMzIDAuNUMxNS4wODkyIDAuNSAwLjUgMTUuMDg5MiAwLjUgMzNDMC41IDUwLjkxMDggMTUuMDg5MiA2NS41IDMzIDY1LjVDNTAuOTEwOCA2NS41IDY1LjUgNTAuOTEwOCA2NS41IDMzQzY1LjUgMTUuMDg5MiA1MC45MTA4IDAuNSAzMyAwLjVaTTMzIDdDNDcuMzk3OSA3IDU5IDE4LjYwMjEgNTkgMzNDNTkgNDcuMzk3OSA0Ny4zOTc5IDU5IDMzIDU5QzE4LjYwMjEgNTkgNyA0Ny4zOTc5IDcgMzNDNyAxOC42MDIxIDE4LjYwMjEgNyAzMyA3WiIgZmlsbD0iIzEyOURGRiIvPgo8cGF0aCBkPSJNMTcuNTYyNSAzNi42NTYyVjI5LjM0MzhIMjMuNzM0M0gyOS45MDZIMzYuMDc3OEg0Mi4yNDk1SDQ4LjQyMTNWMzYuNjU2MkgzNi4wNzc4SDI5LjkwNkgxNy41NjI1WiIgZmlsbD0iIzEyOURGRiIvPgo8L3N2Zz4K";